// extracted by mini-css-extract-plugin
export var aside = "Aside-module--aside--2f4f5";
export var asideNoRule = "Aside-module--asideNoRule--47f7b";
export var cdsAssistiveText = "Aside-module--cds--assistive-text--478e4";
export var cdsVisuallyHidden = "Aside-module--cds--visually-hidden--431f6";
export var hideFeedback = "Aside-module--hide-feedback--24391";
export var showFeedback = "Aside-module--show-feedback--3582f";
export var skeleton = "Aside-module--skeleton--6668a";